import React from 'react';
import { FaInstagram, FaWhatsapp } from 'react-icons/fa';
import ThemeToggle from './ThemeToggle';
import { siteConfig } from '../data/site';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { href: '/#home', label: 'Início' },
    { href: '/#servicos', label: 'Serviços' },
    { href: '/#projetos', label: 'Projetos' },
    { href: '/#sobre', label: 'Sobre' },
    { href: '/#faq', label: 'FAQ' },
    { href: '/#contato', label: 'Contato' },
    { href: '/orcamento', label: 'Orçamento' },
  ];

  return (
    <footer className="bg-dark-bg dark:bg-black text-cream py-16 border-t border-burnt/10 transition-colors duration-500">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={siteConfig.logoRound}
                alt="MS Digitais"
                className="h-12 w-12 object-contain"
              />
              <span className="font-heading font-bold text-xl">MS Digitais</span>
            </div>
            <p className="text-cream/70 font-body max-w-md leading-relaxed mb-6">
              Desenvolvimento de sites institucionais modernos e sistemas personalizados.
              Transformo ideias em soluções digitais que geram credibilidade e resultados.
            </p>
            <a
              href="/portfolio"
              className="inline-flex items-center justify-center px-8 py-3.5 rounded-xl bg-burnt text-white text-base font-heading font-semibold hover:bg-primary-600 transition-colors shadow-premium"
              data-cursor="pointer"
            >
              Apresentação / Portfólio
            </a>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold uppercase tracking-wider text-burnt mb-4">
              Navegação
            </h3>
            <ul className="space-y-2">
              {links.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-cream/70 hover:text-burnt transition-colors font-body text-sm"
                    data-cursor="pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-heading font-semibold uppercase tracking-wider text-burnt mb-4">
              Contato
            </h3>
            <div className="flex gap-3 mb-4">
              <a
                href={siteConfig.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cream/5 p-3 rounded-xl hover:bg-burnt transition-all duration-300 transform hover:scale-110 border border-cream/10"
                aria-label={`Instagram ${siteConfig.instagramHandle}`}
                data-cursor="pointer"
              >
                <FaInstagram className="text-xl" />
              </a>
              <a
                href={`https://wa.me/${siteConfig.whatsappNumber}`}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-cream/5 p-3 rounded-xl hover:bg-burnt transition-all duration-300 transform hover:scale-110 border border-cream/10"
                aria-label="WhatsApp"
                data-cursor="pointer"
              >
                <FaWhatsapp className="text-xl" />
              </a>
            </div>
            <p className="text-cream/60 text-sm font-body mb-4">
              {siteConfig.instagramHandle}
            </p>
            <ThemeToggle />
          </div>
        </div>

        <div className="border-t border-cream/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/50 font-body text-sm text-center md:text-left">
            © {currentYear} Monise Da Silva · MS Digitais. Todos os direitos reservados.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <a
              href="/politica-de-privacidade"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cream/60 hover:text-burnt transition-colors font-body text-sm"
              data-cursor="pointer"
            >
              Política de Privacidade
            </a>
            <p className="text-cream/40 font-body text-xs">
              Sites institucionais · Sistemas personalizados
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
